import { Card, Clickable } from '@warp-ds/react';
import { useConfig } from 'shared/config/ConfigContext';
import type { LmsLocationFacet } from '@/interfaces/lms';
import { formatCount, getRelatedDestinations } from './getRelatedDestinations';

type LmsRelatedDestinationsProps = {
    destinationQueries: string[];
    locationFacet?: LmsLocationFacet[];
};

export const LmsRelatedDestinations = ({ destinationQueries, locationFacet }: LmsRelatedDestinationsProps) => {
    const { contextPathLMS } = useConfig();
    const links = getRelatedDestinations(destinationQueries, locationFacet);

    if (links.length === 0) {
        return null;
    }

    return (
        <section className="mt-32 space-y-16" data-testid="relatedDestinations">
            <h2 className="text-l font-bold">Andre populære restplasser</h2>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-16 list-none p-0 m-0">
                {links.map((link) => (
                    <li key={link.til}>
                        <Card className="w-full">
                            <div className="relative p-16">
                                <h3 className="text-m font-bold m-0">
                                    <Clickable
                                        href={`${contextPathLMS}?til=${link.til}`}
                                        className="s-text hover:no-underline focus:no-underline">
                                        {link.label}
                                    </Clickable>
                                </h3>
                                <p className="text-xs s-text-subtle mt-4 mb-0">{`${formatCount(link.count)} ledige restplasser`}</p>
                            </div>
                        </Card>
                    </li>
                ))}
            </ul>
            <p className="s-text-subtle text-s">
                Antall ledige restplasser varierer fra dag til dag, siden dette er reiser med avreise i nær fremtid.
            </p>
        </section>
    );
};
